import React, { useState } from "react";
import * as moment from "moment";

import "./SavestFlexible.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Loader from "react-loader-spinner";

import { BankTranferDetailsTextInput } from "../../../../../../Formik/BankDetailsInput";
import BankTranferDetailsSelect from "../../../../../../Formik/BankDetailsSelect";
import {
  StyledBankTransferFormButton,
  ButtonGroup,
  colors,
} from "../../../../../../../Syles/styles";

import * as Yup from "yup";
import { Util } from "../../../../../../../../helpers/util";
import "../../../savest.css";
import { Input } from "@material-ui/core";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const daysOptions = days.map((day, key) => (
  <option value={day} key={key}>
    {day}
  </option>
));
const validationSchema = Yup.object({
  product: Yup.string().required("Please select a product").oneOf(days),
  frequency: Yup.string()
    .required("Please select your saving period")
    .oneOf(["daily", "weekly", "monthly"]),
  email: Yup.string().email().required(),
  title: Yup.string().required(),
  review: Yup.string().required(),
  rating: Yup.number().min(1).max(10).required(),
  date: Yup.date().default(() => new Date()),
  wouldRecommend: Yup.boolean().default(false),
});

const renderError = (message) => <p className="name">{message}</p>;
const CreateFlexible = ({ setMenu }) => {
  const [fields, setFields] = useState({
    frequency: "monthly",
    payment_date: "",
    start_date: moment().add(1, "day").format("yyyy-MM-DD"),
  });

  const handleNextClick = () => {
    const payload = Util.get("create_flexible_plan", fields);
    Util.set("create_flexible_plan", { ...payload, ...fields });
    console.log("clicked");

    setMenu(3);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFields({ ...fields, [name]: value });
  };

  return (
    <div className="create-flexible-plan">
      <div className="create-flexible-plan-main">
        <div className="create-flexible-header">
          <h5 className="create-flexible-h5">Create Flexible Plan</h5>
          <p className="create-flexible-p">
            Save strictly for emergencies and earn up to 3.5% every 15 days.
          </p>
        </div>
        <div className="savest-amount-tosave">
          <p className="savest-amount-p">How often would you like to save ? </p>
          <Formik
            validationSchema={validationSchema}
            initialValues={
              {
                // fields
              }
            }
            onSubmit={(values, { setSubmitting, setFieldError }) => {
              console.log(values);
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <input
                  type="radio"
                  id="html"
                  name="frequency"
                  onChange={handleInputChange}
                  value="daily"
                  className=" mt-3"
                />
                <label htmlFor="" className="savest-plan-label">
                  Daily
                </label>
                <br />
                <input
                  type="radio"
                  id="html"
                  name="frequency"
                  onChange={handleInputChange}
                  value="weekly"
                  className=" mt-4"
                />
                <label htmlFor="" className="savest-plan-label">
                  Once a week
                </label>

                <br />
                <input
                  type="radio"
                  id="html"
                  name="frequency"
                  onChange={handleInputChange}
                  value="monthly"
                  className=" mt-4"
                />
                <label htmlFor="" className="savest-plan-label">
                  Once a month
                </label>
                <div className="amount-targeted">
                  <p className="savest-amount-p2 mt-5">Payment date</p>
                  {/* <BankTranferDetailsTextInput
                  name="payment_date"
                  onChange={handleInputChange}
                  value={}
                  type="tel"
                  placeholder="Monday"
                /> */}

                  <BankTranferDetailsSelect
                    onChange={handleInputChange}
                    name="payment_date"
                    as="select"
                  >
                    <option className="select-day">Select a Day</option>
                    {daysOptions}
                  </BankTranferDetailsSelect>
                  <ErrorMessage name="name" render={renderError} />

                  <p className="savest-amount-p2 mt-5">
                    When would you like to start saving?
                  </p>

                  <BankTranferDetailsTextInput
                    name="start_date"
                    type="date"
                    value={fields.start_date}
                    onChange={handleInputChange}
                    placeholder="DD/MM/YYYY"
                  />
                </div>

                <ButtonGroup>
                  {!isSubmitting && (
                    <StyledBankTransferFormButton onClick={handleNextClick}>
                      Next
                    </StyledBankTransferFormButton>
                  )}

                  {isSubmitting && (
                    <Loader
                      type="ThreeDots"
                      color={colors.primary}
                      height={49}
                      width={100}
                    />
                  )}
                </ButtonGroup>
                {/* <button type="submit" className="savest-button">
                  Next
                </button> */}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CreateFlexible;
